/* eslint-disable */
function mobileNavigation()
{
		var n = $("#js-mobile-navigation"),
				a = $("#js-mobile-menu-button"),
				e = $("#js-navigation-set");
		$(window).on("load resize", function()
		{
				942 >= $(window).innerWidth() ? 0 == $("#js-mobile-navigation ul").length && (a.show(), $(n).append($(e).clone()), $("#js-mobile-navigation ul li span").each(function()
				{
						if ("0" != $(this).next().length)
						{
								$(this).addClass("parent");
								var n = $(this).children("a").text();
								$(this).parent("li").append('<span data-name="' + n + '" data-rt-icon="&#x64;" class="next"></span>')
						}
				})) : 0 == $("#js-navigation-bar ul").length && (a.hide(), $("#js-mobile-navigation").find($(".clone").remove()), $(".next").remove())
		}),
		n.on("click", "span.mm-parent,span.mm-child--title", function(event){
			event.preventDefault();
			$(event.currentTarget).siblings('.next').trigger('click');
		}),
		n.on("click", "span.next", function(e)
		{
			e.stopPropagation();
			e.preventDefault();
			e.stopImmediatePropagation();

			$(this).siblings("span").closest("ul").addClass("hide");

			let $new = $(this).prev("ul").clone().addClass("clone").appendTo(n);
			let a = $(this).attr("data-name");
			$('<li><span class="back"><a><span class="icon-caret--left"></span>  Back</a></span></li>').prependTo($new);

				if ($(".navigation-trail").length)
				{
					let e = $(this).parent("li").siblings(".navigation-trail").clone();
					$(e).children("span").append(" / " + a), e.prependTo($new);
				}
				else
				{
					let e = $('<li class="navigation-trail"><span>Home</span></li>').prependTo($new);
					$(e).children("span").append(" / " + a)
				}
		}), n.on("click", "span.back", function(n)
		{
			n.stopPropagation();
			n.preventDefault();
			n.stopImmediatePropagation();

			$(this).closest("ul").prev("ul").removeClass("hide");

			let breadcrumb = $("a.root").text();
			let last = breadcrumb.substr(breadcrumb.lastIndexOf(" / ") + 1);
			let $old = $(this).closest("ul");
			$old.remove();

			$("a.root").html(function(n, a)
				{
						return a.replace(last, "")
				})
		})
}
window, mobileNavigation = new mobileNavigation, $("#js-mobile-navigation span.parent").on("click", function()
{
		$(this).parent().find(".next").last().click()
}), $("body").on("click", ".mobile-menu-button", function()
{
		$("body").toggleClass("mobile-menu-active mobile-menu-left-open"), $("html").toggleClass("h-mobile-menu-active mobile-menu-left-open")
});
